var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.3 0.644531H14.6C18 0.644531 19.9 2.54453 19.9 5.94453V15.2445C19.9 18.6445 18 20.5445 14.6 20.5445H5.3C1.9 20.5445 0 18.6445 0 15.2445V5.94453C0 2.54453 1.9 0.644531 5.3 0.644531ZM9.2 9.84453H6.4C6.2 9.84453 6 9.84453 5.8 10.0445C5.7 10.2445 5.6 10.4445 5.6 10.6445C5.6 11.1445 6 11.4445 6.4 11.4445H13.7C14.2 11.4445 14.5 11.0445 14.5 10.6445C14.5 10.2445 14.1 9.84453 13.7 9.84453H10.9",
    fill: "#00538f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/Minus.7c42f19a7cc28358a150caaafd078170.svg";
export { ForwardRef as ReactComponent };